import { DataTable } from 'primereact/datatable';
import CONSTANTS from '../../constants';
import { Column } from 'primereact/column';
import styles from './TemplateModal.module.css';
import { getMonthFormatDate, getTimestamp } from '../../utils/getDate.utils';

const typesTemplate = (rowData, fieldData) => {
	const list = rowData[`${fieldData.field}`];
	return (
		<div className={styles.list}>
			{list.map((type) => (
				<div>{type}</div>
			))}
		</div>
	);
};

const unitValueTemplate = (rowData, fieldData) => {
	const unitValueObject = rowData[`${fieldData.field}`];
	return (
		<div className={styles.unitValue}>
			<div>{unitValueObject.value}</div>
			<div>{unitValueObject.unit}</div>
		</div>
	);
};

const dateTemplate = (rowData, fieldData) => {
	if (!rowData[`${fieldData.field}`]) return <span></span>;
	const convertedTimestamp = getTimestamp(rowData[`${fieldData.field}`]);
	const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
	const time = convertedTimestamp?.split(' ')[1];
	const ampm = convertedTimestamp?.split(' ')[2];
	return <span>{`${date} ${time} ${ampm}`}</span>;
};

const TemplateModal = (props) => {
	const { templateData } = props;
	// console.log(templateData);
	return (
		<div>
			<DataTable
				value={[templateData]}
				rowClassName={styles.row}
				header={templateData.templateName}
			>
				{CONSTANTS.templateDetailColumns.map((col) => (
					<Column key={col.field} field={col.field} header={col.header} />
				))}
				<Column
					field="consentTypes"
					header="Consent Types"
					body={typesTemplate}
				></Column>
				<Column field="fiTypes" header="FI Types" body={typesTemplate}></Column>
				<Column
					field="Frequency"
					header="Frequency"
					body={unitValueTemplate}
				></Column>
				<Column
					field="DataLife"
					header="Data Life"
					body={unitValueTemplate}
				></Column>
				<Column
					field="ConsentExpiry"
					header="Consent Expiry"
					body={unitValueTemplate}
				></Column>
				{/* <Column
					body={dateTemplate}
					field="creationDate"
					header="Creation Date"
				></Column> */}
				<Column
					body={dateTemplate}
					field="approvedDate"
					header="Approved Date"
				></Column>
				<Column
					body={dateTemplate}
					field="updationDate"
					header="Updated Date"
				></Column>
			</DataTable>
		</div>
	);
};

export default TemplateModal;
